'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var PropTypes$1 = _interopDefault(require('prop-types'));
require('styled-components');
var _babelHelpers = require('../_babelHelpers-48e7a7f7.js');
require('../settings-9ee2f03f.js');
require('../style-222d2b0f.js');
require('../typography/span.js');
require('../buttons-color-d198c1b7.js');
var buttonIcon = require('./button-icon.js');

var Button = function Button(_ref) {
  var text = _ref.text,
      children = _ref.children,
      loading = _ref.loading,
      loaded = _ref.loaded,
      onClick = _ref.onClick,
      hasIcon = _ref.hasIcon,
      leftIcon = _ref.leftIcon,
      props = _babelHelpers.objectWithoutProperties(_ref, ["text", "children", "loading", "loaded", "onClick", "hasIcon", "leftIcon"]);

  if (loading) {
    return React__default.createElement(
      buttonIcon.StyledButton,
      props,
      React__default.createElement(buttonIcon.ButtonIcon, { className: "fas fa-circle-notch fa-spin", size: "18", gap: "0" })
    );
  }

  return React__default.createElement(
    buttonIcon.StyledButton,
    _babelHelpers._extends({}, props, { onClick: onClick, as: "button" }),
    leftIcon && React__default.createElement(buttonIcon.ButtonIcon, { mr: true, className: "fal fa-angle-left" }),
    text && text,
    children && children,
    hasIcon && React__default.createElement(buttonIcon.ButtonIcon, { ml: true, className: "fal fa-angle-right" })
  );
};

Button.propTypes = {
  /** Button ID */
  id: PropTypes$1.string.isRequired,
  /** button text */
  text: PropTypes$1.string,
  /** type of button */
  type: PropTypes$1.oneOf(["button", "submit"]),
  /** indicator for button size */
  large: PropTypes$1.bool,
  /** indicator for button size */
  small: PropTypes$1.bool,
  /** indicator for button size */
  extraLarge: PropTypes$1.bool,
  /** indicator for showing shadow of the button */
  shadow: PropTypes$1.bool,
  /** indicator for showing arrow icon on the button */
  hasIcon: PropTypes$1.bool,
  /** style for semi bold text in the component */
  semiBold: PropTypes$1.bool,
  /** style for displaying text in black color */
  blackText: PropTypes$1.bool,
  /** style for displaying text in blue color */
  blueText: PropTypes$1.bool,
  /** margin style for component */
  margin: PropTypes$1.string,
  /** padding style for component */
  padding: PropTypes$1.string,
  /** function for handle click action */
  onClick: PropTypes$1.func,
  /** google style button */
  google: PropTypes$1.bool,
  /** facebook style button */
  facebook: PropTypes$1.bool,
  /** transparent style button */
  transparentBtn: PropTypes$1.bool,
  /** indicator for showing arrow icon on the left button */
  leftIcon: PropTypes$1.bool
};
Button.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Button",
  "props": {
    "id": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": "Button ID"
    },
    "text": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "button text"
    },
    "type": {
      "type": {
        "name": "enum",
        "value": [{
          "value": "\"button\"",
          "computed": false
        }, {
          "value": "\"submit\"",
          "computed": false
        }]
      },
      "required": false,
      "description": "type of button"
    },
    "large": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "indicator for button size"
    },
    "small": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "indicator for button size"
    },
    "extraLarge": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "indicator for button size"
    },
    "shadow": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "indicator for showing shadow of the button"
    },
    "hasIcon": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "indicator for showing arrow icon on the button"
    },
    "semiBold": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "style for semi bold text in the component"
    },
    "blackText": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "style for displaying text in black color"
    },
    "blueText": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "style for displaying text in blue color"
    },
    "margin": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "margin style for component"
    },
    "padding": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "padding style for component"
    },
    "onClick": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "function for handle click action"
    },
    "google": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "google style button"
    },
    "facebook": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "facebook style button"
    },
    "transparentBtn": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "transparent style button"
    },
    "leftIcon": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "indicator for showing arrow icon on the left button"
    }
  }
};

module.exports = Button;
//# sourceMappingURL=index.js.map
